/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';

import {ContactSelectConstants} from './contact-select-actions';
import {Dispatcher} from '../../flux-helpers';

class ContactSelectStore extends ReduceStore {

    getInitialState() {
        return Immutable.Map({
            hasError: false,
            isLoading: false,
            options: Immutable.List(),
            requestId: 0,
            searchTerm: ''
        });
    }

    reduce(state, action) {
        switch (action.actionType) {
        case ContactSelectConstants.CONTACTS.CLEAR:
            state = this.getInitialState();
            break;
        case ContactSelectConstants.CONTACTS.GET.ERROR: {
            const {requestId} = action;
            if (requestId === state.get('requestId')) {
                state = state.merge({
                    hasError: true,
                    isLoading: false,
                    options: Immutable.List()
                });
            }
            break;
        }
        case ContactSelectConstants.CONTACTS.GET.START: {
            const {requestId, searchTerm} = action;
            state = state.merge({
                hasError: false,
                isLoading: true,
                requestId,
                searchTerm
            });
            break;
        }
        case ContactSelectConstants.CONTACTS.GET.SUCCESS: {
            const {options, requestId} = action;
            if (requestId === state.get('requestId')) {
                state = state.merge({
                    hasError: false,
                    isLoading: false,
                    options
                });
            }
            break;
        }
        }
        return state;
    }

}

let store = new ContactSelectStore(Dispatcher);
export default store;
